module.exports = __webpack_public_path__ + "static/media/5.22.cd31a0c7.png";